import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import GenericLoader from '../../components/Loader/GenericLoader';
import DynamicTabsComponent from '../../components/DynamicTabs/DynamicTabsComponent';
import { useLocation } from 'react-router-dom';
import LeaveListComponent from './ApplyLeave/LeaveListComponent';
import LeavesStatusComponent from './LeavesStatus/LeavesStatusComponent';
import { LeavesLoaderAttribute, SET_DATE_RANGE } from '../../constants';
import { useDispatch } from 'react-redux';
import { YYYY_MM_DD } from '../Tasks/TaskConstants';
import { MAIN_BLUE } from '../../color';
import { cardComponentExpand } from '../../modules/cardState/cardAction';
import moment from 'moment';
import { setFilterDataState } from '../../modules/filter/filterAction';

const LeavesComponent = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const xyz = new URLSearchParams(location.search).get('xyz');
  const searchString = window.atob(xyz);

  const leaveStartDate = new URLSearchParams(searchString).get('startDate');
  const leaveEndDate = new URLSearchParams(searchString).get('endDate');
  const tabType = new URLSearchParams(searchString).get('type');
  const leaveStatus = new URLSearchParams(searchString).get('status');

  const [loader, setLoader] = React.useState(false);

  const [activeTab, setActiveTab] = React.useState(() => {
    if (tabType) {
      if (tabType === 'LEAVE') return 1;
      if (tabType === 'WFH') return 2;
    } else {
      return 0;
    }
  });

  useEffect(() => {
    if (tabType) {
      if (tabType === 'LEAVE') {
        setActiveTab(1);
      }
      if (tabType === 'WFH') setActiveTab(2);
      dispatch(
        setFilterDataState({
          startDate: leaveStartDate,
          endDate: leaveEndDate,
          status: leaveStatus,
        }),
      );
      dispatch({
        type: SET_DATE_RANGE,
        data: {
          startDate: moment(leaveStartDate).format(YYYY_MM_DD),
          endDate: moment(leaveEndDate).format(YYYY_MM_DD),
          color: MAIN_BLUE,
        },
      });
      dispatch(cardComponentExpand());
    } else {
      setActiveTab(0);
    }
  }, [location]);

  // const LeavesTabs = [
  //   // {
  //   //   title: 'Leaves Summary',
  //   //   index: 0,
  //   //   component: <LeavesStatusComponent />,
  //   // },
  //   {
  //     title: 'Leaves List',
  //     index: 1,
  //     component: <LeaveListComponent />,
  //   },
  // ];

  return (
    <div>
      {loader ? (
        <div>
          <GenericLoader rectAttributes={LeavesLoaderAttribute} />
        </div>
      ) : (
          <LeaveListComponent />
      )}
    </div>
  );
};

export default LeavesComponent;
